import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from 'src/app/constants/constants';
import { LoggedInUserDetails } from 'src/app/models/LoggedInUserDetails';
import { SidebarItem } from 'src/app/models/SidebarItem';
import { ClientAccount, UserMetadata } from 'src/app/models/UserMetadata';
import { HomeService } from 'src/app/modules/home/home.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-select-client',
  templateUrl: './select-client.component.html',
  styleUrls: ['./select-client.component.scss']
})
export class SelectClientComponent implements OnInit {
  userMetadata: UserMetadata | null = null;
  allClients: ClientAccount[] = [];
  currentClient: ClientAccount | null = null;
  role: string = '';
  @Output() close: EventEmitter<null> = new EventEmitter<null>();

  constructor(
    private storageService: StorageService,
    private router: Router,
    private homeService: HomeService,
  ){};

  ngOnInit(): void {
    this.userMetadata = this.storageService.getItem('user_metadata');
    this.currentClient = this.storageService.getItem('current_client');
    this.role = this.storageService.getItem('role');
    this.allClients = this.userMetadata?.client_accounts ?? [];
  }

  onSelectClient(event: MouseEvent, client: ClientAccount): void{
    event.stopPropagation();

    let accessibleRoutes: SidebarItem[] = Constants.getAccessibleSidebarItems(this.role);

    /* Selected the same client */
    if(this.currentClient?.unique_key === client.unique_key){
      this.router.navigateByUrl(`${accessibleRoutes[0].navUrl}`);
      return;
    }

    /* Selected a new client */
    this.clearLocalStorage();

    Constants.MAIN_MEMBER_DETAILS_ROUTE = `member-details/${client?.path_key}`;

    if(this.userMetadata) this.userMetadata['x_api_key'] = client.x_api_key;
    this.homeService.setCurrentClient(client);

    this.storageService.setItem('current_client', client);
    this.storageService.setItem('user_metadata', this.userMetadata);

    this.homeService.getUserDetailsData(null).subscribe({
      next: (response: any) => {
        const userDetails: LoggedInUserDetails = response.data;

        this.storageService.setItem('logged_in_user_details', userDetails);

        const role: string = userDetails?.roles?.[0].role ?? Constants.CARE_MANAGER_ROLE;
        this.storageService.setItem('role', role);

        this.homeService.setUserDetails(userDetails);

        accessibleRoutes = Constants.getAccessibleSidebarItems(role);
        this.router.navigateByUrl(`${accessibleRoutes[0].navUrl}`);
      }
    });
  }

  onClientClose(event: MouseEvent): void{
    event.stopPropagation();
    this.close.emit();
  }

  clearLocalStorage(): void{
    localStorage.removeItem('master');
    localStorage.removeItem('coaches');
    localStorage.removeItem('logged_in_user_details');
  }
}
